import { NavLink, BlogPost } from './types';

// "Kontakt" steckt im Button "Position besprechen" und bleibt im Footer.
export const NAV_LINKS: NavLink[] = [
  { name: 'Für Unternehmen', path: '/fuer-unternehmen' },
  { name: 'IT Headhunter', path: '/headhunter-it-berlin' },
  { name: 'Für Kandidaten', path: '/fuer-kandidaten' },
  { name: 'Berufe', path: '/berufe' },
  { name: 'Über uns', path: '/ueber-uns' },
  { name: 'Blog', path: '/blog' },
];

export const SERVICE_LINKS: NavLink[] = [
  { name: 'IT Personalberatung', path: '/fuer-unternehmen' },
  { name: 'IT Headhunter Berlin', path: '/headhunter-it-berlin' },
  { name: 'IT-Karriereberatung', path: '/fuer-kandidaten' },
  { name: 'IT-Berufe und Gehälter', path: '/berufe' },
  { name: 'Kontakt', path: '/kontakt' },
];

export const KONTAKT = {
  telefon: '+49 177 6610166',
  telefonHref: '+491776610166',
  email: 'kontakt@djiiga.com',
  strasse: 'Lynarstraße 17',
  ort: '14193 Berlin',
  linkedin: 'https://www.linkedin.com/company/3084061',
};

// Blog Post Metadaten
export const BLOG_POSTS: BlogPost[] = [
  {
    id: '16',
    slug: '80000-euro-gehalt-it-realistisch',
    seoTitle: '80.000 Euro Gehalt in der IT: Ab wann realistisch?',
    title: '80.000 Euro Gehalt in der IT: Ab wann das realistisch ist',
    excerpt: 'Ab wann 80.000 Euro in der IT realistisch sind, was netto bleibt und welche Rollen die Marke erreichen. Mit Zahlen von Destatis, Stepstone und WTW.',
    content: '',
    author: 'Siamak Mohtachemi',
    date: '14. Oktober 2026',
    category: 'Arbeitsmarkt',
    imageUrl: '/images/80000-euro-gehalt-it-2026.avif',
    imageAlt: 'Softwareentwicklerin liest am Abend an ihrem Schreibtisch ein Vertragsangebot, daneben ein Laptop mit Code, im Hintergrund die Berliner Skyline mit Fernsehturm und Dom'
  },
  {
    id: '17',
    slug: 'neue-mitarbeiter-verdienen-mehr-als-langjaehrige',
    seoTitle: 'Neue Mitarbeiter verdienen mehr: Was das kostet',
    title: 'Neue Mitarbeiter verdienen mehr als langjährige: Was das Gefälle Ihr Team kostet',
    excerpt: 'Neueinstellungen kommen zum Marktpreis, Bestandsgehälter steigen um gut 3 Prozent. Warum das Gefälle bald sichtbar wird und was Sie vorher tun sollten.',
    content: '',
    author: 'Kamran Essam',
    date: '14. Oktober 2026',
    category: 'Recruiting',
    imageUrl: '/images/neue-mitarbeiter-verdienen-mehr-2026.avif',
    imageAlt: 'Erfahrener Entwickler erklärt einer neuen Kollegin am Abend etwas auf einem Monitor, im Hintergrund die Berliner Skyline mit Fernsehturm'
  },
  {
    id: '14',
    slug: 'digitale-souveraenitaet-open-source-fachkraefte-2026',
    seoTitle: 'Digitale Souveränität: Wer betreibt die Systeme?',
    title: 'Digitale Souveränität: Wer soll die offenen Systeme eigentlich betreiben?',
    excerpt: 'Kiel arbeitet seit September ohne Windows, Schleswig-Holstein hat 40.000 Postfächer migriert. Über Lizenzkosten wird viel geredet, über die nötigen Fachkräfte kaum. Welche Profile diese Umstiege brauchen.',
    content: '',
    author: 'Siamak Mohtachemi',
    date: '23. September 2026',
    category: 'Arbeitsmarkt',
    imageUrl: '/images/digitale-souveraenitaet-2026.avif',
    imageAlt: 'Administrator in einem Verwaltungsbüro am Abend vor zwei Bildschirmen, links ein laufendes Update im Terminal, daneben eine abgehakte Migrationscheckliste'
  },
  {
    id: '15',
    slug: 'ki-jobs-deutschland-anwender-entwickler-2026',
    seoTitle: 'KI-Jobs 2026: Sieben Anwender, ein Entwickler',
    title: 'KI-Jobs in Deutschland: Auf eine Entwicklerrolle kommen sieben Anwenderrollen',
    excerpt: 'Nur 1,3 Prozent der Stellenanzeigen haben KI-Bezug, und nur 12 Prozent der Unternehmen mit offenen IT-Stellen suchen KI-Fachkräfte. Was die Zahlen von PwC und Bitkom für die Karriereplanung bedeuten.',
    content: '',
    author: 'Kamran Essam',
    date: '24. September 2026',
    category: 'KI & Machine Learning',
    imageUrl: '/images/ki-jobs-deutschland-2026.avif',
    imageAlt: 'Zwei Kolleginnen und Kollegen besprechen am Abend eine Auswertung auf einem Bildschirm, im Hintergrund die Berliner Skyline'
  },
  {
    id: '13',
    slug: 'gehaltstransparenz-softwareentwickler-2026',
    seoTitle: 'Gehaltstransparenz 2026: Was Sie fragen dürfen',
    title: 'Gehaltstransparenz 2026: Was Softwareentwickler schon jetzt fragen dürfen',
    excerpt: 'Die Pflicht zur Gehaltsspanne gilt noch nicht, Deutschland hat die EU-Frist verpasst. Was Sie im Bewerbungsprozess trotzdem schon fragen dürfen, und warum IT-Stellen beim Gehalt am verschlossensten sind.',
    content: '',
    author: 'Kamran Essam',
    date: '17. September 2026',
    category: 'Recruiting',
    imageUrl: '/images/gehaltstransparenz-2026.avif',
    imageAlt: 'Bewerbungsgespräch am Abend in einem Berliner Büro, zwischen den Gesprächspartnern liegt ein Vertragsangebot auf dem Tisch, im Hintergrund der Fernsehturm'
  },
  {
    id: '12',
    slug: 'softwareentwickler-arbeitsmarkt-berlin-2026',
    seoTitle: 'Softwareentwickler Berlin 2026: Wer gesucht wird',
    title: 'Softwareentwickler-Arbeitsmarkt Berlin 2026: Welche Entwickler jetzt wirklich gefragt sind',
    excerpt: 'Rekord bei arbeitslosen IT-Fachkräften, gleichzeitig steigende Stellenzahlen in Berlin. Was die Daten der Bundesagentur, der IBB und des Indeed Hiring Lab für Entwickler und Arbeitgeber bedeuten.',
    content: '',
    author: 'Siamak Mohtachemi',
    date: '9. September 2026',
    category: 'Arbeitsmarkt',
    imageUrl: '/images/softwareentwickler-berlin-2026.avif',
    imageAlt: 'Zwei Entwickler besprechen Code an einem Arbeitsplatz in einem Berliner Büro am Abend, im Hintergrund die Skyline mit Fernsehturm'
  },
  {
    id: '10',
    slug: 'soc-analyst-gehalt-2026',
    seoTitle: 'SOC Analyst Gehalt 2026: Was Analysten verdienen',
    title: 'SOC Analyst Gehalt 2026: Was IT-Security-Analysten wirklich verdienen',
    excerpt: 'SOC Analyst, IT Security Analyst, Security Engineer: Die Gehaltsangaben reichen von 38.000 bis über 100.000 Euro. Wir trennen die Rollen und zeigen, was den Unterschied macht.',
    content: '',
    author: 'Kamran Essam',
    date: '8. September 2026',
    category: 'Cybersecurity',
    imageUrl: '/images/soc-analyst-gehalt-2026.avif',
    imageAlt: 'Security-Analyst in der Spätschicht vor mehreren Monitoren mit Dashboards, im Hintergrund die Berliner Skyline bei Nacht'
  },
  {
    id: '11',
    slug: 'cloud-engineer-gehalt-2026',
    seoTitle: 'Cloud Engineer & DevOps Gehalt 2026',
    title: 'Cloud Engineer und DevOps Gehalt 2026: Warum die Angaben 30.000 Euro auseinanderliegen',
    excerpt: 'Cloud Engineer, DevOps, Platform Engineer, SRE: vier Bezeichnungen, oft dieselbe Arbeit, sehr unterschiedliche Gehälter. Aktuelle Zahlen für Deutschland und den Berliner Markt.',
    content: '',
    author: 'Siamak Mohtachemi',
    date: '8. September 2026',
    category: 'Cloud Computing',
    imageUrl: '/images/cloud-engineer-gehalt-2026.avif',
    imageAlt: 'Cloud Engineer an einem Stehschreibtisch vor einem Monitor mit Terminal und Deployment-Pipeline, im Hintergrund Berlin am Abend'
  },
  {
    id: '7',
    slug: 'eu-ai-act-rollen-recruiting-2026',
    seoTitle: 'EU AI Act 2026: Diese Rollen brauchen Sie jetzt',
    title: 'EU AI Act ab August 2026: Diese Rollen brauchen Unternehmen jetzt',
    excerpt: 'Seit dem 2. August 2026 ist der EU AI Act durchsetzbares Recht. Welche Pflichten gelten, welche Profile dafür gebraucht werden, von AI Compliance Manager über AI Governance Lead bis Data Governance Engineer, und was sie kosten.',
    content: '',
    author: 'Siamak Mohtachemi',
    date: '26. August 2026',
    category: 'KI & Machine Learning',
    imageUrl: '/images/eu-ai-act-rollen-recruiting-2026.avif'
  },
  {
    id: '8',
    slug: 'cloud-architect-gehalt-2026',
    seoTitle: 'Cloud Architect Gehalt 2026: AWS, Azure, GCP',
    title: 'Cloud Architect Gehalt 2026: Warum die Zahlen so weit auseinandergehen',
    excerpt: 'Cloud Architect, Solution Architect, AWS und Azure: Gehaltsportale nennen zwischen 67.000 und 115.000 Euro. Woran das liegt, welche Faktoren wirklich wirken und wie Sie Ihr Band eingrenzen.',
    content: '',
    author: 'Kamran Essam',
    date: '20. August 2026',
    category: 'Cloud Computing',
    imageUrl: '/images/cloud-architect-gehalt-2026.avif'
  },
  {
    id: '9',
    slug: 'it-fachkraeftemangel-2026-berlin',
    seoTitle: 'IT-Fachkräftemangel 2026: 79.000 offene Stellen',
    title: 'IT-Fachkräftemangel 2026: Warum 79.000 offene Stellen schwerer zu besetzen sind als 149.000',
    excerpt: 'Der Mangel hat sich in drei Jahren fast halbiert, auf 79.000 offene Stellen. Trotzdem tun sich 97 Prozent der Unternehmen mit der Besetzung schwer. Vier Stellschrauben, die messbar wirken.',
    content: '',
    author: 'Siamak Mohtachemi',
    date: '12. August 2026',
    category: 'Recruiting',
    imageUrl: '/images/it-fachkraeftemangel-2026-berlin.avif'
  },
  {
    id: '6',
    slug: 'machine-learning-python',
    seoTitle: 'Machine Learning mit Python: Der Einstieg',
    title: 'Machine Learning mit Python 2026: Vom Anfänger zum Praktiker',
    excerpt: 'Machine Learning mit Python lernen: Scikit-learn, TensorFlow & PyTorch im Vergleich. Praktischer Einstieg mit Code-Beispielen, häufige Anfängerfehler und der optimale Lernpfad für 2026.',
    content: '',
    author: 'Kamran Essam',
    date: '30. Januar 2026',
    category: 'KI & Machine Learning',
    imageUrl: '/images/machine-learning-python.avif'
  },
  {
    id: '5',
    slug: 'aiops-2026',
    seoTitle: 'AIOps 2026: Wie KI den IT-Betrieb verändert',
    title: 'AIOps 2026: Wie künstliche Intelligenz DevOps revolutioniert',
    excerpt: 'AIOps nutzt Machine Learning und Big Data, um IT-Betrieb zu automatisieren. Erfahren Sie, wie Sie AIOps implementieren, welche Tools 2026 führend sind und warum traditionelles DevOps an Grenzen stößt.',
    content: '',
    author: 'Kamran Essam',
    date: '30. Januar 2026',
    category: 'KI & Machine Learning',
    imageUrl: '/images/aiops-2026-devops-ki.avif'
  },
  {
    id: '1',
    slug: 'ki-entwickler-gehalt-karriere-deutschland-2025',
    seoTitle: 'KI-Entwickler Gehalt 2026: Was KI Engineers verdienen',
    title: 'KI-Entwickler Gehalt 2026: Was KI Engineers wirklich verdienen und warum die Zahlen streuen',
    excerpt: 'Zwischen 64.700 und 73.400 Euro Durchschnitt, je nach Quelle. Was KI-Entwickler nach Erfahrung verdienen, warum Prototypen weniger zählen als Produktivsysteme und welche Faktoren das Gehalt tatsächlich bewegen.',
    content: '',
    author: 'Kamran Essam',
    date: '15. September 2025',
    updated: '19. Oktober 2026',
    category: 'KI & Machine Learning',
    imageUrl: '/images/ki-entwickler-gehalt.avif',
    imageAlt: 'Entwicklerarbeitsplatz mit Code und Diagrammen zu einem KI-Modell',
  },
  {
    id: '2',
    slug: 'cybersecurity-gehalt-it-security-jobs-deutschland',
    seoTitle: 'Cyber Security Gehalt 2026: Einstieg bis Architekt',
    title: 'Cyber Security Gehalt 2026: Was IT-Sicherheit vom Einstieg bis zum Architekten zahlt',
    excerpt: 'Einstieg um 55.400 Euro, Security Engineers um 72.000 Euro, Architekten deutlich darüber. Warum der Durchschnitt in der IT-Sicherheit wenig aussagt, welche Rolle NIS2 spielt und welche Zertifikate sich lohnen.',
    content: '',
    author: 'Siamak Mohtachemi',
    date: '8. September 2025',
    updated: '19. Oktober 2026',
    category: 'Cybersecurity',
    imageUrl: '/images/cybersecurity-gehalt-it-security-jobs.avif',
    imageAlt: 'Sicherheitsanalyst vor Monitoren mit Netzwerk- und Ereignisdaten',
  },
  {
    id: '3',
    slug: 'cloud-computing-jobs-gehalt-aws-azure-karriere',
    seoTitle: 'Cloud-Karriere 2026: Rollen, Zertifikate, Gehalt',
    title: 'Cloud-Karriere 2026: Rollen, Zertifikate und Gehälter vom Engineer bis zum Architect',
    excerpt: 'Cloud Engineer, Platform Engineer, Cloud Architect: Was die Rollen unterscheidet, welche Zertifikate wann helfen, was sie 2026 verdienen und warum europäische Cloud-Anbieter die Nachfrage verschieben.',
    content: '',
    author: 'Kamran Essam',
    date: '1. September 2025',
    updated: '19. Oktober 2026',
    category: 'Cloud Computing',
    imageUrl: '/images/cloud-computing-jobs-gehalt-aws-azure-karriere.avif',
    imageAlt: 'Schaubild einer Cloud-Architektur auf einem Bildschirm',
  },
  {
    id: '4',
    slug: 'remote-work-digital-transformation-it-jobs',
    seoTitle: 'Remote Work in der IT 2026: Zahlen und Gehalt',
    title: 'Remote Work in der IT 2026: Wie viel Homeoffice bleibt und was das für Gehalt und Bewerbung bedeutet',
    excerpt: 'Jede fünfte Stellenanzeige bietet Homeoffice, in Großstädten deutlich mehr. Was die Zahlen von ifo und Bertelsmann Stiftung zeigen, warum Remote die Gehälter angleicht und worauf Kandidaten und Unternehmen achten sollten.',
    content: '',
    author: 'Siamak Mohtachemi',
    date: '25. August 2025',
    updated: '19. Oktober 2026',
    category: 'Remote Work',
    imageUrl: '/images/remote-work.avif',
    imageAlt: 'Arbeitsplatz im Homeoffice mit Laptop und Videokonferenz',
  },
];
